/**
 * Bloy caches product collection IDs after the first cart calculation.
 * Newly added items then get empty collectionIds, so exclusion rules are skipped
 * until a full page reload. This patch fills missing collection IDs from Liquid
 * and asks Bloy to recalculate after AJAX cart updates.
 *
 * Collection IDs must be strings — Bloy calls .split('/') on them.
 */
(function bloyCartSync() {
  const nativeFetch = window.fetch.bind(window);

  function readThemeCollections() {
    const el = document.getElementById('bloy-cart-collections');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  function normalizeCollectionIds(ids) {
    if (!Array.isArray(ids)) return [];
    return ids.map((id) => String(id)).filter((id) => id && id !== 'undefined' && id !== 'null');
  }

  function wrapCollectionsMap(apiMap) {
    const base = apiMap && typeof apiMap === 'object' ? { ...apiMap } : {};
    return new Proxy(base, {
      get(target, prop, receiver) {
        try {
          if (typeof prop === 'symbol') return Reflect.get(target, prop, receiver);
          if (prop === 'then') return undefined;

          const key = String(prop);
          const existing = normalizeCollectionIds(target[key]);
          if (existing.length) return existing;

          const fromTheme = normalizeCollectionIds(readThemeCollections()[key]);
          if (fromTheme.length) return fromTheme;

          return existing;
        } catch (error) {
          return [];
        }
      }
    });
  }

  window.fetch = function bloyPatchedFetch(input, init) {
    const url = typeof input === 'string'
      ? input
      : (input instanceof URL ? input.href : (input && input.url) || '');
    const request = nativeFetch(input, init);

    if (url.indexOf('/shopifyResource/cart/collections') === -1) return request;

    return request.then((res) => {
      const originalJson = res.json.bind(res);
      res.json = function bloyPatchedJson() {
        return originalJson().then((data) => {
          if (data && typeof data === 'object') {
            data.collectionsByProduct = wrapCollectionsMap(data.collectionsByProduct);
          }
          return data;
        });
      };
      return res;
    });
  };

  let refreshTimer;

  function refreshBloyCartPoints() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => {
      document.dispatchEvent(new Event('BloyCartDataUpdated'));
    }, 250);
  }

  document.addEventListener('on:cart:add', () => {
    window.setTimeout(refreshBloyCartPoints, 900);
  });
  document.addEventListener('on:line-item:change', () => {
    window.setTimeout(refreshBloyCartPoints, 150);
  });
  document.addEventListener('on:cart-drawer:after-open', refreshBloyCartPoints);

  function observeCartMeta() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;

    let lastJson = '';
    const observer = new MutationObserver(() => {
      const el = document.getElementById('bloy-cart-collections');
      const json = el ? el.textContent.trim() : '';
      if (json && json !== lastJson) {
        lastJson = json;
        refreshBloyCartPoints();
      }
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartMeta);
  } else {
    observeCartMeta();
  }
})();
